export default __webpack_public_path__ + "static/media/Bitter-Steel Band.11baea25.jpg";